import { InformationOffOutlineIcon } from './InformationOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 25B8EEBF-60AA-422C-8E9C-E8D6004E9614
 * name information-off-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-off-outline.svg
 * tags
 */
export const InformationCircleOffOutlineIcon = InformationOffOutlineIcon;
export default InformationCircleOffOutlineIcon